












































































































































































import { prefs, getYubinBango } from "@/common/assets/js/utils/address";
import TheTemplateM from "@/general/components/templates/TheTemplateM.vue";
import InputText from "@/common/components/atoms/InputText.vue";
import InputSelect from "@/common/components/atoms/InputSelect.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";

import FormLabel from "@/common/components/organisms/FormLabel.vue";
import FormZipcode from "@/common/components/organisms/FormZipcode.vue";
import FormUneditableText from "@/common/components/atoms/FormUneditableText.vue";
import ValidationErrorText from "@/common/components/atoms/ValidationErrorText.vue";
import { extend, ValidationProvider, ValidationObserver } from "vee-validate";
import { required, max } from "vee-validate/dist/rules";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import {
  getPersonalAddressDetails,
  getPersonalAddressUpdate
} from "@/general/store/api";
import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";

extend("required", {
  ...required,
  message: "{_field_}を入力してください。"
});
extend("max", {
  ...max,
  message: "{_field_}は{length}文字以内を入力してください。"
});

@Component({
  components: {
    TheTemplateM,
    InputText,
    InputSelect,
    ButtonMain,
    FormLabel,
    FormZipcode,
    FormUneditableText,
    ValidationErrorText,
    ValidationProvider,
    ValidationObserver
  }
})
export default class PersonalInfoUpdate extends Vue {
  userInfo: any = {};
  loaded = false;
  id = 0;
  name: any;
  pref: any;
  zipcode: any;
  address1: any;
  address2: any;
  address3: any;
  telephone: any;
  prefOptions = [{ value: "", label: "都道府県を選択してください" }, ...prefs];

  breadcrumb = [
    {
      text: "",
      url: "/home/",
      pageType: "home"
    },
    {
      text: "マイページ",
      url: "/my-page/",
      pageType: "lower"
    },
    {
      text: "個人情報登録",
      url: "/",
      pageType: "lower"
    }
  ];

  @Watch("zipcode")
  onZipcode() {
    getYubinBango(this, "zipcode", "pref", "address1", "address2");
  }

  submit(ObserverProps: any) {
    ObserverProps.passes(() => {
      this.$refs.form as Vue & { submit: () => any };
    });
  }

  get personalAddress() {
    return {
      name: "",
      id: this.id,
      user: this.userInfo.id,
      zip_code: this.zipcode,
      prefecture: this.pref,
      municipality: this.address3,
      phone_number: this.telephone,
      address_line_1: this.address1,
      address_line_2: this.address2
    };
  }

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();

    const responseGet = await getPersonalAddressDetails();

    this.userInfo = JSON.parse(LocalStorage.getItem("userDetails") as string);
    this.name = commons.getNameFromUser(this.userInfo);

    if (responseGet && responseGet.results && responseGet.results.length > 0) {
      const address = responseGet.results[0];
      this.id = address.id;
      this.zipcode = address.zip_code;
      this.pref = address.prefecture;
      this.address1 = address.address_line_1;
      this.address2 = address.address_line_2;
      this.address3 = address.municipality;
      this.telephone = address.phone_number;

      this.loaded = true;
    }

    await commons.getBreadcrumb(this.breadcrumb);
  }

  async submitAddress() {
    await getPersonalAddressUpdate(this.id, this.personalAddress, "");
    window.location.href = "/my-page/personalInformationUpdated.html";
  }
}
